<template>
  <div class="fill-height">
    <v-container v-if="loading" class="fill-height">
      <v-row>
        <v-col>
          <v-progress-circular indeterminate />
        </v-col>
      </v-row>
    </v-container>

    <template v-else-if="trainingRegistration && trainingRegistration.training">
      <!--course content quiz timer-->
      <v-row
        v-if="isQuizRunning"
        class="primary ma-0 py-1"
        justify="center"
        align="center"
      >
        <v-col class="text-start ps-8">
          <span class="text-h6 light--text">
            {{ $t("course.timedQuiz") }}
          </span>
        </v-col>

        <v-spacer />

        <v-col class="text-end pe-16">
          <div class="d-flex justify-end align-center">
            <span class="light--text textLight rounded-2 px-4 text-h4">
              <v-icon size="30" color="white" class="pe-1">
                mdi-timer-outline
              </v-icon>

              <span ref="quizTimerText"> 00:00 </span>
            </span>

            <div
              class="text-start ms-3 subtitle-2 light--text font-weight-light"
            >
              <p class="ma-0">
                {{ $t("course.minutes") }}
              </p>

              <p class="ma-0">
                {{ $t("course.remaining") }}
              </p>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-container fluid class="fill-height align-start pa-8">
        <v-row>
          <!--course content-->
          <v-col
            v-if="selectedTrainingProgress"
            cols="12"
            md="7"
            class="pe-md-8"
          >
            <CourseModuleContent
              id="courseModuleContent"
              :trainingRegistration="trainingRegistration"
              :selectedTrainingProgress="selectedTrainingProgress"
              @onModuleContentCompleted="onTrainingProgressSelection"
              @onTrainingCompleted="onTrainingCompleted"
              @onQuizTimerUpdate="onQuizTimerUpdate"
              @onError="snackbar = true"
            />
          </v-col>

          <!--course about, instructions syllabus-->
          <v-col v-else cols="12" md="7" class="pe-md-8">
            <CourseAboutAndSyllabus
              :trainingRegistration="trainingRegistration"
            />
          </v-col>

          <!--course progress-->
          <v-col
            cols="12"
            md="5"
            class="ps-md-8 pt-8 pt-md-3"
            :style="
              $vuetify.breakpoint.mdAndUp
                ? 'border-inline-start: 1px solid rgba(0, 0, 0, 0.12)'
                : 'border-top: 1px solid rgba(0, 0, 0, 0.12)'
            "
          >
            <CourseProgress
              :trainingRegistration="trainingRegistration"
              @onSelected="onTrainingProgressSelection"
              @onError="snackbar = true"
            />
          </v-col>
        </v-row>
      </v-container>

      <CourseFeedbackFormDialog :trainingRegistration="trainingRegistration" />
    </template>

    <v-container v-else class="fill-height">
      <Error />
    </v-container>

    <v-snackbar v-model="snackbar" timeout="3000">
      {{ $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Error from "../../core-module/components/Error";
import CourseModuleContent from "../components/CourseModuleContent";
import CourseAboutAndSyllabus from "../components/CourseAboutAndSyllabus";
import CourseProgress from "../components/CourseProgress";
import CourseFeedbackForm from "@/app/course-module/components/CourseFeedbackForm";
import CourseFeedbackFormDialog from "@/app/course-module/components/CourseFeedbackFormDialog";

export default {
  name: "CourseDetailsPage",
  components: {
    Error,
    CourseModuleContent,
    CourseAboutAndSyllabus,
    CourseProgress,
    CourseFeedbackFormDialog,
  },
  data() {
    return {
      snackbar: false,
      loading: true,
      trainingRegistration: null,
      selectedTrainingProgress: null,
      isQuizRunning: false,
    };
  },
  created() {
    if (this.$route.params.trainingRegistration) {
      this.trainingRegistration = this.$route.params.trainingRegistration;
      this.mapTrainingProgressWithTrainingModuleContent();
      this.loading = false;
    } else if (this.$route.params.trainingRegistrationId) {
      this.$apollo.addSmartQuery("getTrainingRegistration", {
        query: require("../api/query/getTrainingRegistration.gql"),
        variables: { id: this.$route.params.trainingRegistrationId },
        result({ data, loading }) {
          if (data && data.getTrainingRegistration) {
            this.trainingRegistration = data.getTrainingRegistration;
            this.mapTrainingProgressWithTrainingModuleContent();
          }

          this.loading = loading;
        },
      });
    }
  },
  methods: {
    mapTrainingProgressWithTrainingModuleContent() {
      //TODO:TRAINING: if a training have, updated or deleted module content
      this.trainingRegistration =
        this.filterTrainingModulesInTrainingRegistration(
          this.trainingRegistration
        );

      if (this.trainingRegistration?.training) {
        this.trainingRegistration.training.trainingModules =
          this.trainingRegistration.training.trainingModules?.map(
            (trainingModule, trainingModuleIndex) => {
              trainingModule.trainingModuleContents =
                trainingModule.trainingModuleContents?.map(
                  (trainingModuleContent, trainingModuleContentIndex) => {
                    const trainingProgress =
                      this.trainingRegistration.trainingProgresses?.find(
                        x =>
                          x.trainingModuleContent?._id ===
                          trainingModuleContent._id
                      );

                    if (trainingProgress) {
                      trainingProgress.trainingModule = trainingModule;
                      trainingProgress.trainingModuleIndex =
                        trainingModuleIndex;
                      trainingProgress.trainingModuleContentIndex =
                        trainingModuleContentIndex;
                      trainingModuleContent.trainingProgress = trainingProgress;
                    }

                    return trainingModuleContent;
                  }
                );

              return trainingModule;
            }
          );
      }
    },
    onTrainingProgressSelection(trainingProgress) {
      this.selectedTrainingProgress = trainingProgress;

      setTimeout(() => {
        const el = document.getElementById("courseModuleContent");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    },
    onTrainingCompleted() {
      this.$router.replace({
        name: "CourseCertificateDownload",
        params: { id: this.trainingRegistration._id },
      });
    },
    onQuizTimerUpdate(quizTimerObject) {
      this.isQuizRunning = quizTimerObject.isQuizRunning;

      if (this.$refs["quizTimerText"]) {
        this.$refs["quizTimerText"].innerText = quizTimerObject.duration;
      }
    },
  },
};
</script>

<style lang="scss" scoped />
